// @ts-check
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { resetPassword } from "../../../redux/auth/actions";
import { Button, Form } from "react-bootstrap";
import { APP_CONST } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";

const ResetPassword = ({ show, handleClose, handleModalShow }) => {
  const [isVerifying, setIsVerifying] = useState(false);
  const [formData, setFormData] = useState({
    otp: "",
    password: "",
  });

  /**
   *
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.otp === "" || formData.password === "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
      return;
    }
    setIsVerifying(true);
    const response = await resetPassword(formData);
    setIsVerifying(false);
    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
      handleClose();
      handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal LoginModal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="black"
      >
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="login-section ForgotPasswordSection">
          <div className="Login-rightPart ForgotPassword">
            <div className="form-steps">
              <h2 className="h2">Verify!</h2>
              <p>Please enter OTP you received on your mobile number</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type="text"
                    placeholder="Enter OTP*"
                    onChange={(e) =>
                      setFormData((p) => ({ ...p, otp: e.target.value }))
                    }
                  />
                  <Form.Control
                    type="password"
                    placeholder="Enter new password"
                    onChange={(e) =>
                      setFormData((p) => ({ ...p, password: e.target.value }))
                    }
                  />
                </Form.Group>
                <Button variant="primary" disabled={isVerifying} type="submit">
                  {!isVerifying ? "SUBMIT" : "SUBMITTING"}
                </Button>
              </Form>

              <div className="sign-up mt-4">
                Already a member?
                <br />
                <a
                  onClick={() => {
                    handleClose();
                    handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                  }}
                >
                  Log In here
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ResetPassword;
